import React from 'react';
import PropTypes from 'prop-types';
import { Card, Form, Button } from 'react-bootstrap';
const uuid = require('uuid');
const _ = {
    find: require('lodash/find'),
    filter: require('lodash/filter'),
    map: require('lodash/map'),
    forEach: require('lodash/forEach'),
    isEqual: require('lodash/isEqual'),
    isEmpty: require('lodash/isEmpty'),
};
import styled from '@emotion/styled';

const JsonSpan = styled.span`
    white-space: pre-wrap;
    font-family: monospace;
`;

const Globals = require('../../../../app/globals');
//const StringUtil = require('../../../../app/shared/StringUtil');
 const Strings = require('../../../../app/shared/Strings');

import SortableTableClassic from '../table/SortableTableClassic';
import LoadingSpinner from '../loading/LoadingSpinner';
import MultiFilterPaginationControls from '../table/MultiFilterPaginationControls';

const OrganizationActions = require('../../actions/OrganizationActions');
const OrganizationStore = require('../../stores/OrganizationStore');

const CollaboratorActions = require('../../actions/CollaboratorActions');
const CollaboratorStore = require('../../stores/CollaboratorStore');

const GlobalUserStore = require('../../stores/GlobalUserStore');
const GlobalUserActions = require('../../actions/GlobalUserActions');

const ActivityStore = require('../../stores/activity_store_reflux');

import AccessibleIcon from '../common/AccessibleIcon';

const propTypes = {
    orgId: PropTypes.number.isRequired,
    orgName: PropTypes.string.isRequired,
    backHandler: PropTypes.func.isRequired,
};

const defaultProps = {
};

const FEEDBACK_COLUMNS = [
  /*{
        displayName: 'ID',
        key:'id',
        size: 1,
        type: 'int',
    },*/
    {
        displayName: 'Channel',
        key:'channel_name',
        size: 2,
        type: 'string',
    },
    {
        displayName: 'Activity or Course Name',
        key:'activity_or_course_name',
        size: 5,
        type: 'string',
    },
    {
        displayName: 'Version',
        key:'version',
        size: 1,
        type: 'string',
    },
    {
        displayName: 'Create Date',
        key:'created_at',
        size: 2,
        type: 'date',
    },
    {
        displayName: 'Reporter',
        key:'user_name',
        size: 2,
        type: 'string',
    },
    {
        displayName: 'Assigned To',
        key: 'assigned_user_display_name',
        size: 2,
        type: 'string',
    },
    {
        displayName: 'Status',
        key:'status_display_name',
        size: 1,
        type: 'string',
    },
    {
        displayName: 'Category',
        key:'category',
        size: 1,
        type: 'string',
    },
    {
        displayName: 'Comment',
        key:'comment',
        size: 6,
        type: 'string',
    },
];

// decode CollaboratorStore to get possibleAssignees for each project
function getAssignableUsersPerProject() {
    let projectUsers = {};
    const collaboratorStoreState = CollaboratorStore.getState();
    _.forEach(collaboratorStoreState.pCollaborators,(entry,project_id)=>{
        if (entry.initialized) {
            projectUsers[project_id] = []; // TODO
            _.forEach(entry.pCollaborators,(userEntry,k)=>{
                if (userEntry.project_permissions && userEntry.project_permissions.beAssignedComment) {
                    projectUsers[project_id].push({
                        id: userEntry.hash,
                        name: userEntry.display_name || (userEntry.last_name + ', ' + userEntry.first_name),
                    });
                }
            })
        }
    });
    return projectUsers;
}

const STATUS_OPTIONS = [
    { id: Globals.activity_comment.status.OPEN, name: Strings['en'].activity_comment.status.OPEN },
    { id: Globals.activity_comment.status.RESOLVED, name: Strings['en'].activity_comment.status.RESOLVED },
];

class OrgStudentFeedbackView extends React.Component {
    constructor(props) {
        super(props)

        let feedbackStoreState = OrganizationStore.getStateOrganization(props.orgId).orgStudentFeedback;
        let feedback_categories = GlobalUserStore.getState().feedback_categories;

        let commentSearchTerm = '';
        let categorySearchTerm = [];
        let sortBy = '';
        let sortOrder = '';
        let page = 1;
        let categoryOptions = [];
        if (feedbackStoreState && feedbackStoreState.initializedFeedbackComments) {
            commentSearchTerm = feedbackStoreState.commentSearchTerm || '';
            categorySearchTerm = feedbackStoreState.categorySearchTerm || [];
            sortBy = feedbackStoreState.sortBy;
            sortOrder = feedbackStoreState.sortOrder;
            page = feedbackStoreState.page;
        }

        let categoryActionId = null;
        if (feedback_categories) {
            categoryOptions = feedback_categories.slice();
            //categoryOptions.push({id:null, name:'none'});
            categorySearchTerm = _.map(categoryOptions,'id');
        }
        else {
            categoryActionId = uuid.v4();
            GlobalUserActions.getStudentFeedbackCategories(categoryActionId);
        }
        
        let statusSearchTerm = _.map(STATUS_OPTIONS,'id');
        
        let collabActionId = null;
        let allCollabsRequested = false;
        let projectUsers = getAssignableUsersPerProject();
        if (!projectUsers || _.isEmpty(projectUsers)) {
            allCollabsRequested = true;
            collabActionId = uuid.v4();
            CollaboratorActions.getChannelProjectsCollabs(collabActionId, { channelId: props.orgId });
        }
        
        this.state = {
            feedbackStoreState,
            selectedId: null, // selected comment id (if any)
            commentSearchTerm,
            categoryActionId, feedback_categories, categoryOptions, categorySearchTerm, statusSearchTerm,
            sortBy,
            sortOrder,
            page,
            actionId: null,
            collabActionId, projectUsers, allCollabsRequested,
            possibleAssignees: null,
        }
        this.unsubscribes = [
            GlobalUserStore.listen(this.onUserStoreChange),
            OrganizationStore.listen(this.onOrgStoreChange),
            CollaboratorStore.listen(this.onCollaboratorStoreChange),
        ];
    }
    
    componentDidMount() {
        if (!this.state.feedbackStoreState.initializedFeedbackComments) {
            this.doRequestData();
        }
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
        delete this.unsubscribes; // indicates we have dismounted
    }

    onUserStoreChange=(newState)=>{
        const categoryActionMatch = (newState.action.id === this.state.categoryActionId);
        if (categoryActionMatch) {
            let feedback_categories = GlobalUserStore.getState().feedback_categories;
            let categoryOptions = feedback_categories.slice();
            let categorySearchTerm = _.map(categoryOptions,'id');
            let changes = {feedback_categories, categoryOptions, categorySearchTerm, categoryActionId:null};
            this.setState(changes,()=>{
                if (!this.state.feedbackStoreState.initializedFeedbackComments) {
                    this.doRequestData();
                }
            });
        }
    }

    onOrgStoreChange=(newState)=>{
        const actionMatch = (newState.action.id === this.state.actionId);
        const updateActionMatch = (newState.action.id === this.state.updateActionId);
        if (actionMatch || updateActionMatch) {
            let feedbackStoreState = OrganizationStore.getStateOrganization(this.props.orgId).orgStudentFeedback;
            let changes = {feedbackStoreState};
            if (actionMatch) {
                changes.actionId = null;
            }
            if (updateActionMatch) {
                changes.updateActionId = null;
            }
            this.setState(changes);
        }
    }
    
    onCollaboratorStoreChange=(newState)=>{
        const collabActionMatch = (newState.action.id === this.state.collabActionId);
        if (collabActionMatch) {
            let projectUsers = getAssignableUsersPerProject();
            this.setState({collabActionId: null, projectUsers});
        }
    }
    
    handleOptionsFilter=(key,id,value,options)=>{
        let values = [];
        const oldValues = this.state[key];
        _.forEach(options,(cat)=>{
            if (cat.id === id) {
                if (value) {
                    values.push(id);
                }
            }
            else if (oldValues.indexOf(cat.id) >= 0) {
                values.push(cat.id);
            }
        });
        this.setState({[key]: values});
    }
    
    onFilterChange=(key,value,id)=>{
        switch(key) {
            case 'commentSearchTerm':
                this.setState({commentSearchTerm: value});
                return;
            case 'categorySearchTerm':
                return this.handleOptionsFilter(key,id,value,this.state.feedback_categories);
            case 'statusSearchTerm':
                return this.handleOptionsFilter(key,id,value,STATUS_OPTIONS);
        }
        console.log(`onFilterChange(${key},${value},${id}) not handled`);
    }

    requestPage=(page)=>{
        this.setState({page},this.doRequestData);
    }
    
    onSortChange=(sortKey,asc)=>{
        this.setState({
            sortBy: sortKey,
            sortOrder: asc ? 'asc' : 'desc',
        },this.doRequestData);
    }
    
    doRequestData=()=>{
        let actionId = uuid.v4();
        const params = {
            page: this.state.page,
            commentSearchTerm: this.state.commentSearchTerm.trim(),
            categorySearchTerm: this.state.categorySearchTerm,
            statusSearchTerm: this.state.statusSearchTerm,
            sortBy: this.state.sortBy,
            sortOrder: this.state.sortOrder,
        }
        if (this.state.feedbackStoreState && this.state.feedbackStoreState.initializedFeedbackComments) {
            if (this.state.feedbackStoreState.studentFeedbackPagination.numPages < 2) {
                // get all the records and apply the filters on the client
                params.commentSearchTerm = '';
                params.categorySearchTerm = null;
            }
        }

        this.setState({actionId},()=>{
            OrganizationActions.getOrgStudentFeedback(actionId, this.props.orgId, params);
        });
    }
    
    getPossibleAssignees=(selectedFeedback)=>{
        return this.state.projectUsers[selectedFeedback.project_id] || [];
    }
    
    onCommentClick=(e,selectedId)=>{
        if (this.state.updateActionId || this.state.collabActionId) {
            this.setState({selectedFeedbackNote:"Please wait. Update pending."}); // this UI can only handle one update at a time
            return;
        }
        if (this.anySelectedFeedbackChanges()) {
            this.setState({selectedFeedbackNote:"close or update before selecting another row"}); // this UI can only handle one update at a time
            return;
        }
        
        const feedback_comments = this.state.feedbackStoreState.feedback_comments;
        const selectedFeedback = _.find(feedback_comments,{id:selectedId});
        let possibleAssignees = null;
        let allCollabsRequested = this.state.allCollabsRequested;
        let collabActionId = this.state.collabActionId;
        if (selectedFeedback) {
            possibleAssignees = this.getPossibleAssignees(selectedFeedback);
            if (!allCollabsRequested && (!possibleAssignees || !possibleAssignees.length)) {
                allCollabsRequested = true;
                collabActionId = uuid.v4();
            }
        }

        this.setState({selectedId, selectedFeedbackChanges:null, possibleAssignees, collabActionId, allCollabsRequested},()=>{
            if (!this.unsubscribes) {
                return;
            }
            if (collabActionId) {
                CollaboratorActions.getChannelProjectsCollabs(collabActionId, { channelId: this.props.orgId });
            }
        });
    }
    
    anySelectedFeedbackChanges=()=>{
        const selectedFeedbackChanges = this.state.selectedFeedbackChanges;
        if (!selectedFeedbackChanges) {
            return false;
        }
        const feedback_comments = this.state.feedbackStoreState.feedback_comments;
        const selectedFeedback = _.find(feedback_comments,{id:this.state.selectedId});
        if (!selectedFeedback) {
            return false;
        }
        var anyChanges = false;
        _.forEach(selectedFeedbackChanges,(v,k)=>{
            if (selectedFeedback[k] != selectedFeedbackChanges[k]) {
                anyChanges = true;
                return false; // done
            }
        });
        return anyChanges;
    }
    
    onChangeCategory=(val)=>{
        const category_id = Number(val);
        var selectedFeedbackChanges = {...this.state.selectedFeedbackChanges, category_id: Number(val)};
        this.setState({selectedFeedbackChanges});
    }
    
    onAssignComment=(val)=>{
        var selectedFeedbackChanges = {...this.state.selectedFeedbackChanges, assignee_id: val}; // Note: This is the user HASH
        this.setState({selectedFeedbackChanges});
    }
    
    onSetCommentStatus=(val)=>{
        var selectedFeedbackChanges = {...this.state.selectedFeedbackChanges, status: val}; // OPEN or RESOLVED
        this.setState({selectedFeedbackChanges});
    }
    
    updateSelectedFeedback=()=>{
        if (!this.anySelectedFeedbackChanges()) {
            return;
        }
        let params = {...this.state.selectedFeedbackChanges,  id: this.state.selectedId };
        let updateActionId = uuid.v4();
        this.setState({updateActionId,selectedFeedbackChanges:null,selectedFeedbackNote:''},()=>{
            OrganizationActions.updateOrgStudentFeedback(updateActionId, this.props.orgId, params);
        });
    }

    deselectRow=()=>{
        this.setState({
            selectedId:null,
            possibleAssignees: null,
            selectedFeedbackChanges: null,
            selectedFeedbackNote: '',
        });
    }

    goToComment=()=>{
        const feedback_comments = this.state.feedbackStoreState.feedback_comments;
        const comment = _.find(feedback_comments,{id:this.state.selectedId});
        if (comment && comment.activity_id) {
            let route_suffix = '/review'; // punt. could check for lock and try edit
            let url = `/project/${comment.channel_id}/${comment.project_id}/activity/${comment.activity_id}${route_suffix}`;
            
            // tell the editor to navigate to the particular comment, after giving it a chance to load.
            ActivityStore.setEditGotoComment(comment.activity_id, comment.id, comment.location);
            this.props.history.push(url);
            // window.location = url;
        }
    }

    getIntegrationTypeDisplayName=(integrationType)=>{
        switch (integrationType) {
            case Globals.integration_type.GOOGLE_CLASSROOM:
                return 'Google Classroom';
            case Globals.integration_type.LOCAL:
                return 'Local';
            case Globals.integration_type.LTI:
                return 'LTI 1.1';
            case Globals.integration_type.LTI_1_3:
                return 'LTI 1.3';
            case Globals.integration_type.CONNECT:
                return 'Connect';
        }
        return '';
    }

    render() {
        let heading = (
            <div className="channelHeadingFlex">
                <div className="channelHeadingFlex__heading">
                    <button
                    className="btn btn-primary glyph btn-circle btn-lg margin-right-15"
                    onClick={this.props.backHandler}
                    title="Back">
                        <AccessibleIcon label="Back">
                            <span className="fa fa-chevron-left" aria-hidden="true"/>
                        </AccessibleIcon>
                    </button>
                    <h2 className="heading-lg">{this.props.orgName ? ( this.props.orgName + " - Student Feedback" ): "Student Feedback"}</h2>
                </div>
            </div>
        );

        if (!this.state.feedbackStoreState || !this.state.feedbackStoreState.initializedFeedbackComments || !this.state.feedback_categories) {
            return (
                <div>
                    {heading}
                    <LoadingSpinner/>
                </div>
            );
        }

        const ssp = this.state.feedbackStoreState.studentFeedbackPagination;
        const currentPage = ssp.currentPage;
        const numPages = ssp.numPages;
        const filterPages = ssp.filterPages;
        const totalRecords = ssp.totalRecords;

        let anySearchTerms = false;
        if (this.state.commentSearchTerm || this.state.categorySearchTerm) {
            anySearchTerms = true;
        }

        let searchTermsApplied = true;
        if ((this.state.commentSearchTerm.trim() !== ssp.commentSearchTerm) ||
            (!_.isEqual(this.state.categorySearchTerm,ssp.categorySearchTerm))) {
            searchTermsApplied = false;
        }

        const searchTerms = {
            commentSearchTerm: {
                name: "Comment",
                searchTerm: this.state.commentSearchTerm,
            },
            categorySearchTerm: {
                name: "Category",
                searchTerm: this.state.categorySearchTerm,
                options: this.state.categoryOptions,
            },
            statusSearchTerm: {
                name: "Status",
                searchTerm: this.state.statusSearchTerm,
                options: STATUS_OPTIONS,
            },
        };
        
        let feedback_comments = this.state.feedbackStoreState.feedback_comments.map((elem)=>{
            let row = {...elem};
            row.user_name = elem.user_display_name;
            if (!row.user_name) {
                row.user_name = `${elem.user_last_name || ''}, ${elem.user_first_name || ''}`;
            }
            let category = _.find(this.state.feedback_categories,{id: row.category_id}) || {name:''};
            row.category = category.name;
            row.activity_or_course_name = elem.activity_name || elem.course_name;
            row.status_display_name = Strings['en'].activity_comment.status[row.status];
            return row;
        });
        
        // if all the records fit on one page, filter on the client 
        if (numPages < 2) {
            const commentSearchTerm = this.state.commentSearchTerm;
            let categorySearchTerm = this.state.categorySearchTerm;
            if (categorySearchTerm && !categorySearchTerm.length) {
                categorySearchTerm = null;
            }
            let doFilter=(feedbackObj)=>{
                return (
                     (!commentSearchTerm || (feedbackObj.comment && (feedbackObj.comment.toLowerCase().indexOf(commentSearchTerm) >= 0)) ) &&
                     (!categorySearchTerm || (categorySearchTerm.indexOf(feedbackObj.category_id) >= 0 )) &&
                     (this.state.statusSearchTerm.indexOf(feedbackObj.status) >= 0 )
                );
            };
            feedback_comments = _.filter(feedback_comments, (entry) => {
                return doFilter(entry);
            });
        }
        
        const selectedFeedback = _.find(feedback_comments,{id:this.state.selectedId});
        let selectedRowUI = null;
        if (selectedFeedback) {
            let editedSelectedFeedback = { ...selectedFeedback, ...this.state.selectedFeedbackChanges};
            let possibleAssignees = this.state.possibleAssignees || [];
            
            // make sure to allow assigning back to the original value
            if (!_.find(possibleAssignees,{id: selectedFeedback.assignee_id})) {
                possibleAssignees = possibleAssignees.slice();
                let assignee_name = selectedFeedback.assigned_user_display_name || (`${selectedFeedback.assigned_user_last_name}, ${selectedFeedback.assigned_user_first_name}`);
                possibleAssignees.push({id:selectedFeedback.assignee_id, name: assignee_name});
            }
            
            const categories = this.state.feedback_categories;
            selectedRowUI = (
                <Card className="selected-feedback-comment" body bg="light">
                    <h2 className="large-heading-regular margin-bottom-md">
                        {"Selected Feedback Comment"}
                    </h2>
                    <Form className="indented">
                        <div className="row">
                            <label>Category:</label>
                            <select value={editedSelectedFeedback.category_id || ''} onChange={(e)=>{this.onChangeCategory(e.target.value) }}>
                            {categories.map((obj)=>(
                                <option key={obj.id} value={obj.id}>{obj.name}</option>
                            ))}
                            <option hidden key={'n'} value=''>{'Select category...'}</option>
                            </select>
                        </div>
                        <div className="row">
                            <label>{'Date/Time:'}</label>
                            <span>{selectedFeedback.created_at}</span>
                        </div>
                        <div className="row">
                            <label>{'Channel:'}</label>
                            <span>{selectedFeedback.channel_name}</span>
                        </div>
                        {selectedFeedback.activity_name ?
                        <div className="row">
                            <label>{'Activity:'}</label>
                            <span>{selectedFeedback.activity_name + (selectedFeedback.version ? ` version ${selectedFeedback.version}` : '')}</span>
                        </div>
                        :
                        <div className="row">
                            <label>{'Course:'}</label>
                            <span>{selectedFeedback.course_name + (selectedFeedback.version ? ` version ${selectedFeedback.version}` : '')}</span>
                        </div>
                        }
                        <div className="row">
                            <label>{'Template:'}</label>
                            <span>{selectedFeedback.course_name ? 'n/a' : selectedFeedback.template_name}</span>
                        </div>
                        <div className="row">
                            <label>{'Reporter:'}</label>
                            <span>{selectedFeedback.user_display_name || (`${selectedFeedback.user_last_name}, ${selectedFeedback.user_first_name}`)}</span>
                        </div>
                        <div className="row">
                            <label>{'Assigned To:'}</label>
                            <select value={editedSelectedFeedback.assignee_id || ''} onChange={(e)=>{this.onAssignComment(e.target.value) }}>
                            {possibleAssignees.map((obj)=>(
                                <option key={obj.id} value={obj.id}>{obj.name}</option>
                            ))}
                            </select>
                            { this.state.collabActionId ? <LoadingSpinner/> : null }
                        </div>
                        <div className="row">
                            <label>{'Status:'}</label>
                            <select className={"mzl-dropdown status-" + editedSelectedFeedback.status.toLowerCase()} value={editedSelectedFeedback.status} 
                                    onChange={(e)=>{this.onSetCommentStatus(e.target.value)}} >
                                <option className="status-open" value={Globals.activity_comment.status.OPEN}>{Strings['en'].activity_comment.status.OPEN}</option> 
                                <option className="status-resolved" value={Globals.activity_comment.status.RESOLVED}>{Strings['en'].activity_comment.status.RESOLVED}</option> 
                            </select>
                        </div>
                        
                        
                        <div className="row">
                            <label>{'Integration Type:'}</label>
                            <span>{this.getIntegrationTypeDisplayName(selectedFeedback.launch_type)}</span>
                        </div>
                        <div className="row">
                            <label>{'Assignment:'}</label>
                            <span>{selectedFeedback.assignment_name}</span>
                        </div>
                        <div className="row">
                            <label>{'Element:'}</label>
                            <JsonSpan className="json-formatted">{JSON.stringify(selectedFeedback.location,null,2)}</JsonSpan>
                        </div>
                        <div className="row">
                            <label>{'Comment:'}</label>
                            <span>{selectedFeedback.comment}</span>
                        </div>
                    </Form>
                    {this.state.selectedFeedbackNote ? <div className="note">{this.state.selectedFeedbackNote}</div> : null }
                    <Button disabled={!this.state.selectedFeedbackChanges} onClick={this.updateSelectedFeedback}>Update</Button>
                    <Button onClick={this.deselectRow}>Close</Button>
                    {selectedFeedback.activity_id ? <Button onClick={this.goToComment}>Go To Comment</Button> : null}
                </Card>
            );
        }

        return (
            <div className="org-student-feedback-view">
                {heading}
                <MultiFilterPaginationControls
                    id="org-student-feedback-pagination"
                    className="margin-bottom-lg"
                    currentPage={currentPage}
                    numPages={numPages}
                    anySearchTerms={anySearchTerms}
                    searchTermsApplied={searchTermsApplied}
                    filterPages={filterPages}
                    totalRecords={totalRecords}
                    requestPage={this.requestPage}
                    searchTerms={searchTerms}
                    onFilterChange={this.onFilterChange}
                    doApplySearchTerms={this.doRequestData}
                />
                {(this.state.categorySearchTerm.length === 0) ?
                <div className="search-param-error">{'At least one category should be checked'}</div>
                : null }
                {(this.state.statusSearchTerm.length === 0) ?
                <div className="search-param-error">{'At least one status should be checked'}</div>
                : null }

                {selectedRowUI}
                <SortableTableClassic
                    key="t-feedback"
                    title="Feedback"
                    hideFilter
                    uniqueRowKey={"id"}
                    onRowClick={this.onCommentClick}
                    onSortChange={this.onSortChange}
                    rows={feedback_comments}
                    selectedRowKey={!!this.state.selectedComment ? this.state.selectedComment.id : null}
                    dateFormat="YYYY-MM-DD HH:mm:ss"
                    columns={FEEDBACK_COLUMNS}
                />
                {this.state.selectedComment ?
                    <span>TODO selected comment details</span>
                : null }
            </div>
        );
    }
}

OrgStudentFeedbackView.propTypes = propTypes;
OrgStudentFeedbackView.defaultProps = defaultProps;

export default OrgStudentFeedbackView;